import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { ExportType, ReportMenu } from '../../../constants'
import { authService, reportService } from '../../../services'
import { exportFile, formatter } from '../../../util'
import { apiHostname } from '../../../config'

// UI
import { Button, List, Page, Pager } from '../../../components'
import notify from '../../../components/Notification'
import Skeleton from 'antd/lib/skeleton'
import Icon from 'antd/lib/icon'
import Spin from 'antd/lib/spin'
import Tooltip from 'antd/lib/tooltip'

import './styles.css'
import { connect } from 'react-redux'
import { settingOtherService } from '../../../services/setting'
import { Form, Input } from 'antd';
const { Item: FormItem } = Form
const pageSize = 50

export class ReportClientFunding extends Component {
  constructor (props) {
    super(props)
    this.state = {
      endedList: { list: [], total: 0 },
      endingList: { list: [], total: 0 },
      currentPage: 1,
      isLoaded: false,
      loading: false,
      loadingExport: false,
      loadingList: false,
      settings: {},
    }
  }

  componentDidMount () {
    this.fetchList()
    this.fetchOtherSettings()
  }

  render () {
    const { currentPage, loading, loadingExport, loadingList, endedList, endingList, total, settings } = this.state
    const { form } = this.props
    const { getFieldDecorator } = form
    const longFormItemLayout = {
      labelCol: { sm: 6, md: 6, lg: 4 },
      wrapperCol: { sm: 10, md: 10, lg: 14 }
    }

    const endedColumns = [
      {
        title: 'Client',
        width: 9,
        render: ({ id, client }) => <a href={`/clients/${id}`} rel='noopener noreferrer' target='_blank'>{client}</a>
      },
      {
        title: 'Funder',
        width: 5,
        render: ({ funder_id: funderId, funder_fullname: funderName }) => <a href={`/funders/${funderId}`} rel='noopener noreferrer' target='_blank'>{funderName}</a>
      },

      {
        title: 'Ended On',
        width: 4,
        render: ({ end_date }) => formatter.toShortDate(end_date)
      },

      {
        title: 'As of Today',
        width: 4,
        key: 'ip',
        render: ({ end_date }) => `${formatter.getDaysAgo(formatter.duration(end_date))}`
      }
    ]

    const endingColumns = [
      {
        title: 'Client',
        width: 9,
        render: ({ id, client }) => <a href={`/clients/${id}`} rel='noopener noreferrer' target='_blank'>{client}</a>
      },
      {
        title: 'Funder',
        width: 5,
        render: ({ funder_id: funderId, funder_fullname: funderName }) => <a href={`/funders/${funderId}`} rel='noopener noreferrer' target='_blank'>{funderName}</a>
      },

      {
        title: 'Ending On',
        width: 4,
        render: ({ end_date }) => formatter.toShortDate(end_date)
      },

      {
        title: 'Remaining',
        width: 4,
        key: 'ip',
        render: ({ end_date }) => `${formatter.getDaysToGo(formatter.duration(end_date))}`
      }
    ]


    return (
      <Page.Body>
        <Page.Left>
          <Page.Menu title='Home' menu={ReportMenu} />
        </Page.Left>

        <Page.Content full>
          <Page.Header title={`Client's Funding`} >
            { !loading
              ? <Button key={'export'} feedback={loadingExport} onClick={() => this.handleExport()}>
                Export
              </Button>
              : null }
            { !loading
              ? this.hasAccess('listRecipients') 
              ? this.hasAccess('updateRecipient') ?
              <Button ghost key={'save'} feedback={loadingExport} onClick={() => this.handleSave()}>
                Save
              </Button> : null : null
              : null }

          </Page.Header>

          <div className='admin-list'>
            { !loading
              ? this.hasAccess('listRecipients') 
              ? <Form {...longFormItemLayout}>
                   <FormItem label="Weekly Email Recipients">
                          {getFieldDecorator('client_fund_email', {
                          initialValue: settings.client_fund_email,
                          rules: [{ required: true, message: 'Please enter weekly email report recipients' }]
                            })
                          (<Input />)
                          }
                   </FormItem>
                 </Form> : null
              : null }   
          </div>

          <div className='admin-list'>
            <Skeleton loading={loading} active>
              <div className='report-title'>{`Clients with Ended Funding `} <span className='report-tag'>{endedList.total}</span></div>
              <List cols={endedColumns} rows={endedList.list} />

              <div className='report-title'>{`Clients with Ending Funding `} <span className='report-tag'>{endingList.total}</span></div>
              <List cols={endingColumns} rows={endingList.list} />
            </Skeleton>
          </div>
        </Page.Content>
      </Page.Body>
    )
  }

  fetchList () {
    const { currentPage, isLoaded, loading } = this.state
    this.fetchClientFunding({currentPage, isLoaded, loading})
  }

  async fetchClientFunding ({ currentPage, isLoaded = true, loading }) {
    if (this.hasAccess('readClientFundReport')) {
      if (isLoaded) {
        this.setState({ loadingList: true })
      } else {
        this.setState({ loading: true })
      }

      try {
        const { ending, ended } = await reportService.getListByAll(ExportType.REPORT.CLIENT_FUNDING)

        this.setState({
          endingList: ending,
          endedList: ended,
          loading: false,
          loadingList: false,
          isLoaded: true
        }, () => this.toTop())
      } catch (e) {
        notify.error('Unable to get Client Funding Report', 'Please try again later.')
        this.setState({ loading: false, loadingList: false, isLoaded: false  })
      }
    }
  }

  fetchOtherSettings = async () => {
    try {
      this.setState({ loading: true })
      const settings = await settingOtherService.listByPage(1, 0)

      this.setState({ settings: settings.list[0], loading: false })
    } catch (e) {
      notify.error('Unable to load successfully', 'Unable to load settings successfully. Please try again later.')
    }
  }

  handleSave = () => {
    const { form } = this.props
    const { settings } = this.state
    const { validateFields } = form

    validateFields(async (errors, values) => {
      if (!errors) {
        const { id } = settings
        this.setState({ loadingForm: true })

        try {
          let response = await settingOtherService.save(id, values)

          this.setState({ loadingForm: false })
          
          if (response.id) {
            notify.success('Saved successfully', `Settings saved successfully.`)
          } else {
            notify.error('Unable to save successfully', `Unable to save settings successfully. Please try again later.`)
          }
        } catch (e) {
          notify.error('Unable to save successfully', `Unable to save settings successfully. Please try again later.`)
          this.setState({ loadingForm: false })
        }
      }
    })
  }

  onChangePage (page) {
    this.setState({ currentPage: page }, () => {
      this.fetchList()
    })
  }

  handleExport = () => {
    const { loadingExport, loading, loadingList } = this.state

    if (loadingExport || loading || loadingList || !this.hasAccess('readClientFundReport')) return

    this.setState({ loadingExport: true })

    setTimeout(async () => {
      const r = await exportFile.fetchReportExport(ExportType.REPORT.CLIENT_FUNDING)
      this.setState({ loadingExport: false })
    }, 4000)
  }

  hasAccess (accessLevel) {
    return authService.hasAccess(accessLevel)
  }

  toTop () {
    if(window) {
      window.scrollTo(0, 0)
    }
  }
}

const mapDispatchToProps = {
}

const mapStateToProps = (state) => {
  return state
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Form.create()(ReportClientFunding))
